import TermsOfSale from './TermsOfSale';

export default TermsOfSale;
